module.exports = __webpack_public_path__ + "media/Simi-Ft.-Falz-–-Mind-Your-Bizness.5b71af04.mp3";